import React from "react";
import ourteambanner from "../img/team/our-team-banner.jpg";
import esop from "../img/team/esop.png";
import crossline from "../images/background/cross-line2.png";
import sanjay from "../img/team/sanjay-gupta.jpg";
import kanchan from "../img/team/kanchan-gupta.jpg";
import utsav from "../img/team/utsav-gupta.jpg";
import chhavi from "../img/team/chhavi-gupta.jpg";
import puneet from "../img/team/puneet.jpg";
import Antima from "../img/team/antima.jpeg";
import Shailendra from "../img/team/shail.jpeg";
import sanjaybisht from "../img/team/sanjay-bisht.jpg";
import pulkit from "../img/team/pulkit-sharma.jpg";
import Vishnu from "../img/team/vishnu.jpeg";
import rizwan from "../img/team/rizwan.jpg";
import rosy from "../img/team/rosy.jpg";
import raman from "../img/team/raman.jpg";

import akashdeep from "../img/team/akashdeep-sharma.jpg";
import karan from "../img/team/karan-jamwal.jpg";
import sandeep from "../img/team/sandeep.jpg";
import charanjeet from "../img/team/charanjeet-singh.jpg";
import mayank from "../img/team/mayank.jpg";
import ahmad from "../img/team/ahmad-ali.jpg";
import vinay from "../img/team/vinay-gaur.jpg";
import kapil from "../img/team/kapil-dhawan.png";
import akash from "../img/team/akash-tiwari.jpg";
import deepak from "../img/team/deepak-kumar.jpg";
import ramankwatra from "../img/team/raman-kwatra.jpg";
import sandeepbhardwaj from "../img/team/sandeep-bhardwaj.jpg";
import narindra from "../img/team/narindra-dhiman.jpg";
import devesh from "../img/team/devesh.jpg";
import sanjiv from "../img/team/sanjiv-gupta.jpg";
import ankit from "../img/team/ankit.jpg";
import dimple from "../img/team/dimple-bansal.jpg";
import amar from "../img/team/amar-singh.jpg";
import guman from "../img/team/guman-singh.jpg";
import amansharma from "../img/team/aman-sharma.jpg";
import babita from "../img/team/babita.jpg";
import amanpreet from "../img/team/amanpreet-kaur.jpg";
import harinder from "../img/team/harinder-singh.jpg";
import Gurpreet from "../img/team/gurpreet-singh.jpg";
import tapas from "../img/team/tapas.png";
import anurag from "../img/team/anurag-tiwari.jpg";
import amrit from "../img/team/amrit-sagar.jpg";
import vishal from "../img/team/vishal.jpg";
import manju from "../img/team/manju.jpg";
import sanjaykaushik from "../img/team/sanjay-kaushik.jpg";
import sarabjeet from "../img/team/sarabjeet-kaur.jpg";
import sujeet from "../img/team/sujeet-kumar.jpg";
import manish from "../img/team/manish-kumar.jpg";
import sapna from "../img/team/sapna.jpeg";
import akriti from "../img/team/akriti.png";
import sunit from "../img/team/sunit.jpg";
import sahvan from "../img/team/mohd-sahvan.jpg";
import yusuf from "../img/team/yusuf-khan.jpg";
import waseem from "../img/team/waseem-khan.jpg";
import vikas from "../img/team/vikas-kumar.jpg";
import arun from "../img/team/arun.jpg";
import parvinder from "../img/team/parvinder-singh.jpg";
import rohit from "../img/team/rohit-sharma.jpg";
import jagmohan from "../img/team/jagmohan-singh.jpg";
import ArvindKumarMishra from "../img/team/ArvindKumarMishra.jpeg";

import "../css/team.css";

function Ourteam() {
  return (
    <div className="page-content">
      {/* INNER PAGE BANNER */}
      <div
        className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
        data-stellar-background-ratio="0.5"
        style={{ backgroundImage: `url(${ourteambanner})` }}
      >
        <div className="overlay-main bg-black opacity-07" />
        <div className="container">
          <div className="sx-bnr-inr-entry">
            <div className="banner-title-outer">
              <div className="banner-title-name">
                <h2 className="m-tb0">Our Team</h2>
                {/*<p>
                  Our dedicated team embodies expertise and passion, driving our
                  mission to deliver quality and innovation to every project
                </p>*/}
                <p>
                Quality Assurance is at the forefront of our Mission to deliver exceptional products that exceed our 
                clients' expectations. To achieve this , we ensure that the Team comprises of Highly skilled professionals
                with diverse expertise in Research & Development, User Experience. United by a shared passion for 
                excellence, 
                the Team operates with a meticulous focus on detail and a deep understanding of the industry's best 
                practices.We engage
                all our team members -from product development to customer support - in our quality initiatives, 
                ensuring that
                everyone plays a crucial role in maintaining High Standards.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* INNER PAGE BANNER END */}
      {/* ABOUT COMPANY START */}
      <div className="section-full mobile-page-padding p-t80 p-b50 bg-gray">
       {/* <div className="container">
          <div className="section-content">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="about-home-3 m-b30 bg-white">
                  <h3 className="m-t0 m-b20 sx-tilte">
                    ESOP<span style={{ color: "red" }}>*</span> | Under
                    Consideration
                  </h3>
                  <p>
                    Spinoff Technopark Ltd. offers an{" "}
                    <b>Employee Stock Ownership Program (ESOP)</b> to empower
                    its workforce with ownership stakes in the company. This
                    initiative aligns employees' interests with the company's
                    success, fostering a sense of partnership and motivation,
                    while rewarding their contributions with a direct stake in
                    Spinoff's growth and profitability.
                  </p>
                  <ul className="list-angle-right anchor-line">
                    <li>Enhanced Employee Loyalty and Retention</li>
                    <li>Increased Motivation and Productivity</li>
                    <li>Competitive Edge in Talent Acquisition</li>
                  </ul>
                   <div class="text-left">
                                      <a href="javascript:;" class="site-button btn-half"><span>Read More</span></a>
                                  </div>                                                    
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="video-section-full-v2">
                  <div
                    className="video-section-full bg-no-repeat bg-cover bg-center overlay-wraper m-b30"
                    style={{ backgroundImage: `url(${esop})` }}
                  >
                    <div className="overlay-main bg-black opacity-01" />
                    <div className="video-section-inner">
                       <div class="video-section-content">
                                               <a href="https://www.youtube.com/watch?v=gWJVoX8UzW0" class="mfp-video play-now">
                                                  <i class="icon fa fa-play"></i>
                                                  <span class="ripple"></span>
                                              </a> 
                                              <div class="video-section-bottom">
                                                  <h3 class="sx-title text-white">35 Years<br>Experience</h3>
                                              </div> 
                                          </div>  
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>*/}
      </div>
      {/* ABOUT COMPANY END */}
      {/* TITLE START */}
      <div className="section-head p-t50">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{ backgroundImage: `url(${crossline})` }}
          >
            <h3 className="sep-line-one">Founders & Board Members</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b20 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Sanjay Gupta 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sanjay} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sanjay Gupta</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Founder & Managing Director</span>
                        </ins>
                      </span>
                    {/* <p>
                        Sanjay Gupta founder of this company is a chartered
                        accountant and company secretary and have diversified
                        experience of more then 35 years in Various field
                        comprising of Finance, Accounts, taxation, import,
                        export, logistics, banking, secretarial, operation,
                        administration, networking, and besides this HR, and
                        remained Co-promoter of an Engineering company SPRAY
                        ENGINEERING LTD, from 2004-2012, and exited in 2012
                      </p>*/}
                      <p>
                        Sanjay Gupta is a chartered
                        accountant and Company Secretary. He has diversified
                        experience of more than 35 years in various fields
                        comprising of Finance, Accounts, taxation, import-
                        export, logistics, banking, secretarial practices, operation,
                        administration, networking and HR. From 2004-2012, Mr. Sanjay 
                        remained the Co-promoter of an Engineering company called SPRAY
                        ENGINEERING LTD. He exited SPRAY ENGINEERING LTD in 2012 to setup own business.
                      </p>
                    </div>
                  </div>
                </div>
                {/* MRS Kanchan Gupta 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={kanchan} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Kanchan Gupta</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Founder & Director</span>
                        </ins>
                      </span>
                      {/*<p>
                        Mrs Kanchan Gupta, is the founder of the company and
                        involved in administrative decision making, new business
                        strategies, and participating in overall Retail stores
                        operation wrt to Funds flow, and customer feedback, she
                        is a graduate and also looking after the staff
                        motivation and welfare needs, and the back end support
                        provider for the moral booster for the business growth
                        with vision.
                      </p>*/}
                      <p>
                        Kanchan Gupta is 
                        involved in administrative decision making, new business
                        strategies. Her participation in our five retail stores' overall 
                        operation w.r.t. to Funds' flow and customer feedback is exemplary. She
                        is a graduate and  looking after the staff
                        motivation,  welfare needs is her forte. She is the back end support
                        provider w hich is essential for Spinoff's business growth.
                      
                      </p>
                    </div>
                  </div>
                </div>
                {/* Utsav Gupta 3 */}
                <div className="shop-item-list-wrap m-b30">
              <div className="sx-boxs sx-product-box   overflow-hide">
                <div className="sx-thum-bx sx-img-overlay1">
                  <img src={utsav} alt="" />
                </div>
                <div className="sx-info">
                  <h5 className="sx-title">
                    <a href="#">Utsav Gupta</a>
                  </h5>
                 <span class="price">
                                          <ins>
                                              <span>Director</span>
                                          </ins>
                                      </span> 
                  <p>
                    Utsav Gupta is founder member, and son of Mr Sanjay Gupta
                    and Kanchan Gupta, having done management in business
                    studies, looking after the factory operation, with
                    functional reporting of production, design, quality,
                    procurement, sales, logistics, warehousing , IT and social
                    media team.
                  </p>
                </div>
              </div>
            </div>
            {/* Utsav Gupta 3 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={chhavi} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Chhavi Gupta</a>
                      </h5>
                      <span class="price">
                        <ins>
                          <span>Director</span>
                        </ins>
                      </span>
                      {/*
                      <p>
                        Chhavi Gupta is member of the founder family and wife of
                        Utsav Gupta and having done management in business
                        studies looking after administrative work of factory and
                        business at corporate office with functional reporting
                        to the management team and looking after administrative
                        and customer support services.
                      </p>*/}
                        <p>
                        Chhavi Gupta is member of the founder family. Having done her management degree  in business
                        studies, now she looks after administrative work of factory and
                        business at corporate office with functional reporting
                        to the management team. She is an expert in administrative issues 
                        and customer support related services.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Mayank Deva 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={mayank} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Mayank Deva</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>VP- Business Development and Commercial </span>
                        </ins>
                      </span>
                      {/*
                      <p>
                        Mayank Deva, VP- Business Development and Commercial at
                        Spinoff , has over 25 years of Leadership experience in
                        major Telecom companies like Bharti Airtel, Tata
                        Teleservices, Spice ( Voda Idea ) etc ., where he was
                        Regional Head SCM covering Sourcing , Logistics ,
                        Contracting and multi locational warehousing, and
                        executive committee member reporting to CEO .
                      </p>*/}
                      <p>
                        Mayank Deva, VP- Business Development and Commercial at
                        Spinoff , has over 25 years of Leadership experience in
                        major Telecom companies like Bharti Airtel, Tata
                        Teleservices, Spice ( Voda Idea ) etc. His valuable experience in 
                        leading position for Supply Chain Management includes sourcing , logistics ,
                        Contracting, multi location warehousing, and
                        executive committee member reporting to Spinoff's management team.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Puneet 1 */}
               {/* <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={ankit} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Ankit Jain</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Company Secretary</span>
                        </ins>
                      </span>
                      <p>
                        Ankit Jain, Company Secretary at spinoff, has 5 years’
                        experience in Secretarial Compliances. His expertise in MCA
                        fillings, ROC work, Drafting Documents etc. is too good.  Being CA &
                        CMA finalist, he adds a different dimension to Accounting, Taxation
                        and GST matters in the organization. He ensures legal
                        and regulatory framework as well as corporate governance compliance
                        with strategic growth in the organization.
                      </p>
                    </div>
                  </div>
                </div>*/}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TITLE START */}
      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">technical Team</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Puneet 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={puneet} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Puneet</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>CTO</span>
                        </ins>
                      </span>
                      {/*
                      <p>
                        Puneet Wadhawan, an Electronics Engineer is the most
                        hardworking and Brilliant engineer, (and a founder
                        member of technical group of the company) who is not
                        having the word “ not doable” in his dictionary and a
                        true leader is heading R&amp;D, SMT Machine floor, PCB
                        designing, mounting, laying, insertion line, and testing
                        and also production and Design development of any new
                        Electronic lighting product in low voltage and also, any
                        kind of project and now leading the new vertical LITHIUM
                        BATTERY PROJECT coming up in RAJPURA.
                      </p>*/}
                       <p>
                        Puneet Wadhawan is a Technocrat who happens to be a brilliant engineer as well. He is founder
                        member of Technical group of the company. His leadership skills are  
                        heading the future course of R&D, SMT Machine floor, PCB
                        designing, mounting, laying, insertion line, testing, production and
                         design development of any new 
                         Electronic lighting product in low voltage segment. Currently, he is heading the new vertical LITHIUM
                        BATTERY PROJECT for our RAJPURA unit.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Vishnu 4 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={Vishnu} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Vishnu Kaskar</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>GM Technical</span>
                        </ins>
                      </span>
                      {/*
                      <p>
                        My self-Vishnu kaskar having more than 25 years of
                        experience in power electronics field. I have got
                        exposure to design high capacity online ups, battery
                        chargers, high capacity inverters, stabilizers. My role
                        is To design analog and digital power electronic systems
                        from concept to schematic and PCB through to
                        manufacturing. I always worked with my team to develop
                        reliable leading edge analog and digital electronic
                        circuitry, identify and implement next generation
                        products for advanced power systems and support existing
                        products.
                      </p>*/}
                      <p>
                      Vishnu Kaskar brings over 25 years of experience in the power electronics field. His expertise in designing high-capacity online uninterruptible power supplies (UPS), battery chargers, inverters, and stabilizers enhances the technical team’s capabilities. Vishnu oversees the design of analog and digital power electronic systems, guiding projects from conceptual stages through schematics and PCB development to precise manufacturing.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Sanjay Bisht 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sanjaybisht} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sanjay Bisht</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Head Rajpura Branch (Mechanical Engineer)</span>
                        </ins>
                      </span>
                     {/* <p>
                        Sanjay bisht is Mechanical Engineer with more then 8
                        years of experience, and a Good team leader for handling
                        the assigned task and managing operations. He is in
                        charge of Rajpura factory campus, and an expert in
                        Electro mechanical, CNC machines, and also managing
                        production, of lighting, and other verticals under him.
                      </p>*/}
                      <p>
                      Sanjay Bisht, a mechanical engineer with over 8 years of experience, excels as a team leader in managing assigned tasks and operational workflows. He oversees the Rajpura factory campus, leveraging his expertise in electromechanical systems and computer numerical control (CNC) machines to ensure efficient production of lighting and other verticals under his supervision.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Pulkit 3 */}
                {/*<div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={pulkit} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Pulkit Sharma</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Head ESS/Telecom/Lithium Battery Packs</span>
                        </ins>
                      </span>
                     {/* <p>
                        Pulkit Sharma is a Senior Engineer in the R&amp;D
                        Department, specializing as a Testing &amp; Validation
                        Engineer for Lithium-ion Batteries. With 4 years of
                        experience, he has expertise in Electric 2W and 3W
                        Batteries, High Voltage Battery Energy Storage Systems,
                        and has worked in both Service and NPD Departments.
                      </p>
                      <p>
                      Pulkit Sharma serves as a Senior Engineer in the Research and Development (R&D) Department, specializing as a Testing and Validation Engineer for lithium-ion batteries. With 4 years of experience, he possesses expertise in electric two-wheeler (2W) and three-wheeler (3W) batteries, high-voltage battery energy storage systems, and has contributed significantly to both service and new product development (NPD) teams.
                      </p>
                    </div>
                  </div>
                </div>*/}

                {/* Raman 4 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={raman} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Raman</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Production</span>
                        </ins>
                      </span>
                     {/* <p>
                        Raman Kumar, Production Incharge for LED drivers, has 7
                        years of experience in the division. He possesses
                        expertise in testing, repairing, and managing the entire
                        production process, ensuring high-quality and efficient
                        manufacturing of LED drivers.
                      </p>*/}
                      <p>
                      Raman Kumar, Production In-Charge for LED drivers, brings 7 years of experience to the division. He excels in testing, repairing, and overseeing the entire production process, ensuring the high-quality and efficient manufacturing of LED drivers.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Karan 5 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={karan} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Karan Jamwal</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Production Incharge</span>
                        </ins>
                      </span>
                      {/*<p>
                        Karan Jamwal, Production In-Charge with 7 years of
                        experience in the LED lighting division, has expertise
                        in light assembly and managing the entire production
                        process, ensuring efficient and high-quality
                        manufacturing of LED lighting products.
                      </p>*/}
                      <p>
                      Karan Jamwal, Production In-Charge with 7 years of experience in the LED lighting division, demonstrates expertise in light assembly and managing the entire production process. He ensures the efficient and high-quality manufacturing of LED lighting products.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">R&D Engineers</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Rizwan 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={rizwan} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Rizwan</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>R&amp;D Engineer </span>
                        </ins>
                      </span>
                      <p>
                      With 2.5 years of experience in the electronics division, Rizwan specializes in product research, schematic and PCB design, programming (Arduino, ESP32, Atmega), MATLAB, and FPGA board signal integrity. He contributes significantly to the advancement of electronics development.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Rosy 3 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={rosy} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Rosy</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>R&amp;D Engineer </span>
                        </ins>
                      </span>
                      <p>
                      Rosy, an R&D Engineer with 4.5 years of experience in the LED lighting division, excels in PCB design, product testing, and validation. She plays a pivotal role in developing and enhancing high-quality LED lighting solutions.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Akashdeep Sharma 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={akashdeep} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Akashdeep Sharma</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>R&D Engineer</span>
                        </ins>
                      </span>
                      <p>
                      With over 9 years of experience, Akashdeep Sharma, Program Manager, excels in complex project management, planning, resource allocation, and risk mitigation. He leads teams to ensure high-quality, timely delivery, consistently meeting project objectives within budget and scope.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Ahmed Ali 7 */}
              {/*  <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={ahmad} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Ahmad Ali</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>R&D Engineer</span>
                        </ins>
                      </span>
                      {/*<p>
                        As a Mechanical Engineer with 1 year of experience,
                        Ahmed Ali brings a strong background in new product
                        development, tool design handling, and project
                        management. The role involves leveraging expertise in
                        mechanical engineering to drive the development of
                        innovative products, manage complex engineering
                        projects, and utilize advanced design software (CAD,
                        CAE, Solidworks) effectively, with a focus on
                        automation, and manufacturing engineering.
                      </p>
                    </div>
                  </div>
                </div>*/}

                {/* Deepak 7 */}
               <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={deepak} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Deepak Kumar</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>R&D Engineer</span>
                        </ins>
                      </span>
                      <p>
                      With over 4 years of expertise, Deepak Kumar specializes in circuit design, schematic and PCB design, microcontroller programming, embedded systems, and IoT solutions. His commitment to innovation drives the development of cutting-edge electronics, positioning the company as a trusted partner in advanced technology solutions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">Production Engineers</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Sandeep 5 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sandeep} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sandeep</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Electrical Engineer</span>
                        </ins>
                      </span>
                     {/* <p>
                        With 9 years of industry experience, he is a Service
                        Engineer specializing in LED light repair and
                        maintenance, diagnosing issues, performing repairs, and
                        ensuring optimal performance
                      </p>*/}
                      <p>
                      With 9 years of industry experience, Sandeep serves as a Service Engineer specializing in LED light repair and maintenance. He excels in diagnosing issues, performing repairs, and ensuring optimal performance.
                      </p>
                    </div>
                  </div>
                  
                </div>
                {/* Charanjeet Singh 5 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={charanjeet} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Charanjeet Singh</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Electrical Engineer</span>
                        </ins>
                      </span>
                      {/*<p>
                        Charanjit Singh, an electrical engineer with over 5
                        years of experience, manages the production floor,
                        excels in CNC machine operations, and leads his team
                        effectively, ensuring efficient factory operations and a
                        collaborative work environment
                      </p>*/}
                      <p>
                      Charanjeet Singh, an electrical engineer with over 5 years of experience, manages the production floor. He excels in CNC machine operations and leads his team effectively, ensuring efficient factory operations and fostering a collaborative work environment.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">Design Engineers</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Vinay Guar 9  */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={vinay} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Vinay Gaur</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Design Engineer</span>
                        </ins>
                      </span>
                      {/*<p>
                        With 8 years of experience in the automotive rubber
                        industry, He specialize as a Rubber Mold Designer in the
                        Tool Design &amp; Development department. His expertise
                        lies in designing and developing tools for automotive
                        rubber products.
                      </p>*/}
                      <p>
                      With 8 years of experience in the automotive rubber industry, Vinay Gaur specializes as a Rubber Mold Designer in the Tool Design and Development Department. His expertise lies in designing and developing tools for automotive rubber products.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Kapil 9  */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={kapil} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Kapil Dhawan</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Design Engineer</span>
                        </ins>
                      </span>
                      {/*<p>
                        Kapil Dhawan is a highly experienced professional with
                        18+ years in Design & Development, NPD, and Advanced
                        Manufacturing Engineering across the Automotive and Home
                        Appliances sectors. Proficient in 3D modeling (NX11/UG),
                        vmc machining, and plastic injection molding, he has a
                        strong background in product design . His expertise in
                        Lean Manufacturing, team leadership, and
                        cross-functional collaboration has consistently
                        delivered quality, cost, and delivery improvements in
                        various projects.
                      </p>*/}
                      <p>
                      Kapil Dhawan is a highly experienced professional with over 18 years in Design and Development, New Product Development (NPD), and Advanced Manufacturing Engineering across the automotive and home appliances sectors. Proficient in 3D modeling (NX11/UG), VMC machining, and plastic injection molding, he brings a strong background in product design. His expertise in lean manufacturing, team leadership, and cross-functional collaboration consistently delivers improvements in quality, cost, and delivery across various projects.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Akash Tiwari 10  */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={akash} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Akash Tiwari</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Design Engineer</span>
                        </ins>
                      </span>
                      {/*
                      <p>
                        Aakash Tiwari, seasoned Tool Room professional with 6+
                        years of experience in mechanical engineering, mold
                        design, and manufacturing. Adept in molds and die
                        casting machining, and quality control. Successfully
                        managed mold making, repair &amp; modification projects,
                        with a strong focus on process planning and
                        problem-solving. Consistently delivered high-quality
                        results.
                      </p>*/}
                       <p>
                        Aakash Tiwari, seasoned Tool Room professional with 6+
                        years of experience in mechanical engineering, mold
                        design, and manufacturing. Adept in molds and die
                        casting machining, and quality control. Successfully
                        managed mold making, repair &amp; modification projects,
                        with a strong focus on process planning and
                        problem-solving. Consistently delivered high-quality
                        results.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TITLE START */}
      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">Sales Team</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Raman Kwatra 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={ramankwatra} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Raman Kwatra</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Head of Sales Corporate (Pharma Lighting)</span>
                        </ins>
                      </span>
                      {/*<p>
                        Raman Kwatra working in Department of Sales as a Head of
                        Sales Corporate since Aug 2017 and having total 17 years
                        of sale experience with expertise in selling led lights
                        in Pharmaceutical sector. With target oriented approach
                      </p>*/}
                      <p>
                      Raman Kwatra has served as Head of Corporate Sales since August 2017, bringing 17 years of sales experience with a focus on LED lighting solutions for the pharmaceutical sector. His target-oriented approach drives exceptional results in this specialized market.
                      </p>
                    </div>
                  </div>
                </div>
               {/* <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={ArvindKumarMishra} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Arvind Kumar Mishra</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>AGM- Sales & Business Development</span>
                        </ins>
                      </span>
                      <p>
                      Arvind Kumar Mishra, Assistant General Manager of Sales and Business Development, brings over 19 years of extensive experience in the automotive sector. Having worked with companies such as Amara Raja, Exide, Phylion Co Ltd, and CLN Energy, he excels in channel and B2B sales, after-sales functions, and new energy ecosystems. He plays a pivotal role in advancing the organization’s e-mobility, solar, ESS, and UPS lithium battery businesses.
                      </p>
                    </div>
                  </div>
                </div>*/}

                {/* Sandeep Bhardwaj 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sandeepbhardwaj} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sandeep Bhardwaj</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                      {/*<p>
                        Sandeep is having more than 16 years experience in
                        various industries such as mining, electrical
                        manufacturing and medium voltage panels. He is a
                        engineering graduate with MBA in operations . His
                        experience includes sales, tendering, site visits along
                        with order execution of supply and service departments
                        by maintaining a focus on silent and swift working
                        methodology.
                      </p>*/}
                      <p>
                      Sandeep Bhardwaj brings over 16 years of experience across industries such as mining, electrical manufacturing, and medium-voltage panels. An engineering graduate with an MBA in Operations, he excels in sales, tendering, site visits, and order execution within supply and service departments, maintaining a focus on efficient and streamlined operations.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Narindra Dhiman 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={narindra} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Narindra Dhiman</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                      {/*<p>
                        Narinder Dhiman has 15 years of experience in customer
                        relationship management, procurement, store purchasing,
                        sales, and retail accounting, ensuring effective
                        operations and strong client satisfaction in the retail
                        sector.
                      </p>*/}
                      <p>
                      Narindra Dhiman possesses 15 years of experience in customer relationship management, procurement, store purchasing, sales, and retail accounting. He ensures effective operations and fosters strong client satisfaction within the retail sector.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Devesh 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={devesh} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Devesh</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                      {/*<p>
                        Devesh, an MBA graduate, has 8 years of experience as a
                        Sales Manager specializing in hardware items. He excels
                        in driving sales growth, managing client relationships,
                        and implementing strategies to enhance market presence,
                        ensuring successful achievement of sales targets and
                        business objectives.
                      </p>*/}
                      <p>
                      Devesh, an MBA graduate with 8 years of experience as a Sales Manager, specializes in hardware items. He excels in driving sales growth, managing client relationships, and implementing strategies to enhance market presence, ensuring the successful achievement of sales targets and business objectives.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Sanjiv Gupta 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sanjiv} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sanjiv Gupta</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                     {/* <p>
                        Sanjiv Gupta, a management graduate with over 20 years
                        of experience across various industries, specializes in
                        sales. He is a key figure in corporate sales and
                        industry expertise for lighting, hardware, and sheet
                        metal, leveraging his extensive background in these
                        sectors.
                      </p>*/}
                      <p>
                      Sanjiv Gupta, a management graduate with over 20 years of experience across various industries, specializes in sales. He is a key figure in corporate sales, leveraging his extensive expertise in lighting, hardware, and sheet metal to drive business success.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Dimle Bansal 4 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={dimple} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Dimple Bansal</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                      {/*<p>
                        Dimple Bansal, a Store Incharge with 3 years of
                        experience, manages inventory, oversees store
                        operations, and ensures efficient processes, supporting
                        smooth and effective store management for optimal
                        performance and customer satisfaction
                      </p>*/}
                      <p>
                      Dimple Bansal, a Store In-Charge with 3 years of experience, manages inventory, oversees store operations, and ensures efficient processes. She supports seamless store management, contributing to optimal performance and customer satisfaction.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Amar Singh 3 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={amar} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Amar Singh</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                      {/*<p>
                        Amar Singh has nearly 16 years of experience in retail
                        management, including 10 years as a Retail Store Manager
                        and Area Sales Manager for international brands like
                        Reebok, Adidas, and Lakshita International, and 6 years
                        as a Production Manager, overseeing operations and
                        driving sales performance
                      </p>*/}
                      <p>
                      Amar Singh brings nearly 16 years of experience in retail management, including 10 years as a Retail Store Manager and Area Sales Manager for international brands such as Reebok, Adidas, and Lakshita International, and six years as a Production Manager. He excels in overseeing operations and driving sales performance.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Guman Singh 3 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={guman} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Guman Singh</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                     {/* <p>
                        Guman Singh has 14 years of experience in hardware as a
                        Senior Sales Executive, specializing in selling and
                        promoting hardware products, driving sales growth, and
                        building strong customer relationships.
                      </p>*/}
                       <p>
                       Guman Singh, with 14 years of experience as a Senior Sales Executive in the hardware sector, specializes in selling and promoting hardware products. He drives sales growth and builds strong customer relationships, enhancing business success.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Aman Sharma 
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={amansharma} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Aman Sharma</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                      {/*<p>
                        Aman Sharma, a postgraduate engineer, has over 9 years
                        of experience across various industries, including
                        automobile manufacturing and banking, bringing expertise
                        and versatility to diverse engineering and operational
                        roles.
                      </p>
                    </div>
                  </div>
                </div>*/}
                {/* Babita 3 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={babita} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Babita</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                      <p>
                      Babita has honed her sales expertise over the past 4 years at Spinoff Technopark Ltd. She delivers exceptional results through strategic client engagement, effective communication, and consistent target achievement, driving business growth and fostering strong relationships in the technology sector.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Amanapreet Kaur 4 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={amanpreet} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Amanapreet Kaur</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Corporate Sales</span>
                        </ins>
                      </span>
                      <p>
                      Amanpreet Kaur, with 3 years of experience in the sales department, manages residential and commercial lighting projects. She collaborates with her team to provide creative and effective lighting consultation and planning solutions for clients. 
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* TITLE START */}
      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">IT Department</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Harinder Singh 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={harinder} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Harinder Singh</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Team Leader IT Engineer</span>
                        </ins>
                      </span>
                      <p>
                      Harinder Singh, an IT Engineer, oversees all data flow within the group, providing relentless 24/7 IT support, server management, and functional assistance to users across various business locations. Since joining the promoters in 2012, he has led multitasking efforts, including commercial and financial roles, ensuring operational excellence. 
                      </p>
                    </div>
                  </div>
                </div>
                {/* Anurag Tiwari 4 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={anurag} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Anurag Tiwari</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Team Leader Software</span>
                        </ins>
                      </span>
                      <p>
                        {" "}
                        Anurag Tiwari is a dedicated and innovative Software Development Engineer with 2 of experience. Known for delivering robust and efficient solutions, he exhibits a strong passion for technology and a commitment to continuous learning, consistently driving project success and excellence in software development.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Gurpreet Singh 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={Gurpreet} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Gurpreet Singh</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>IT Engineer</span>
                        </ins>
                      </span>
                      <p>
                      Gurpreet Singh, an experienced IT executive, possesses a broad understanding of hardware, software, and networking. He excels in leading teams, driving technology transformation, and ensuring seamless technology operations that support business excellence.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Ashish Mehta 3 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={tapas} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Tapas Kumar Dutta</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>
                            Social Media Manager
                          </span>
                        </ins>
                      </span>
                      <p>
                      With 7+ years of diverse experience, Tapas Kumar Dutta is a results-driven Social Media Manager skilled in digital marketing, content creation, video editing, and graphic design. From building responsive websites to running high-impact social campaigns, Tapas blends creativity with strategy to grow brands online. His tech-savvy edge and passion for innovation make him a strong force in the digital space.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Amrit Sagar 5 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={amrit} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Amrit Sagar</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Graphic Designer Social Media Team</span>
                        </ins>
                      </span>
                      <p>
                      Amrit Sagar, a Graphic Designer with 2 years of experience, specializes in creating visually compelling designs. His expertise lies in translating concepts into impactful visuals, enhancing brand identity, and delivering creative solutions that resonate with target audiences.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Vishal 5 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={vishal} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Vishal Kumar</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Graphic Designer Social Media Team</span>
                        </ins>
                      </span>
                      <p>
                      Vishal Kumar, a passionate Graphic Designer with 2 years of experience, specializes in crafting visually engaging designs. His skills focus on transforming concepts into striking visuals, elevating brand identity, and providing innovative design solutions that deeply connect with audiences.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* SHOP SECTION END */}
      {/* TITLE START */}
      <div className="section-head p-t50">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">Accounts Team</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Sanjay Kaushik 3 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sanjaykaushik} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sanjay Kaushik</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>CFO</span>
                        </ins>
                      </span>
                      <p>
                      Sanjay Kaushik, from the Finance and Audit Department, holds a B.Com and an MBA in Finance with over 15 years of experience. He specializes in financial analysis, reporting, regulatory compliance, and conducting audits to strengthen internal controls and ensure accuracy.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Manju 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={manju} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Manju</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Head Accounts</span>
                        </ins>
                      </span>
                      <p>
                      Manju Thakur, Accounts and Finance Manager at Spinoff, brings over 10 years of expertise in accounting, auditing, finance, and taxation. With experience across manufacturing, construction, IT, and logistics, and holding a B.Com in Finance and CA Intermediate qualifications, she ensures financial stability and drives strategic growth for the organization.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Sarabjeet Kaur 5 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sarabjeet} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sarabjeet Kaur</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Team Member</span>
                        </ins>
                      </span>
                      <p>
                      Sarabjeet Kaur, from the Accounts Department, has 6 years of experience specializing in financial reporting, budgeting, and reconciliation. She excels in maintaining accurate records, ensuring regulatory compliance, and providing insightful analysis to support informed decision-making and efficient financial operations. {/* Corrected spelling and enhanced tone */}
                      </p>
                    </div>
                  </div>
                </div>
                {/* Sujeet Kumar Rajpur 4 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sujeet} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sujeet Kumar</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Team Member</span>
                        </ins>
                      </span>
                      <p>
                      Sujeet Kumar Rajput, an Account Executive with 4 years of experience at Spinoff Technopark Ltd, handles sales and purchase data in Tally Prime, reconciles bank statements, and manages accounts. Skilled in GST, TDS, ITR, and MS Office, he ensures accurate financial operations. {/* Spelled out "four" and improved flow */}
                      </p>
                    </div>
                  </div>
                </div>
                {/* Shailendra */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={Shailendra} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Shailendra</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Team Member</span>
                        </ins>
                      </span>
                      <p>
                      Shailendra Kumar, an Account Executive with 5 years of experience at Spinoff Technopark Ltd, manages sales and purchase data in Tally Prime, reconciles bank statements, and oversees accounts. Proficient in GST, TDS, ITR, and MS Office, he ensures precise financial operations. {/* Added full name from description and enhanced tone */}
                      </p>
                    </div>
                  </div>
                </div>
                {/* Antima */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={Antima} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Antima</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Team Member</span>
                        </ins>
                      </span>
                      <p>
                      Antima, an Account Executive with 4 years of experience at Spinoff Technopark Ltd, manages sales and purchase data in Tally Prime, reconciles bank statements, and oversees accounts. Skilled in GST, TDS, ITR, and MS Office, she ensures accurate financial operations. {/* Corrected gender and improved flow */}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* SHOP SECTION END */}
      {/* TITLE START */}
      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">HR &amp; Admin Team</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Manish Kumar 1 */}
                     <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sapna} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sapna Bhatia</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Talent Acquisition -Manager and HR Operations</span>
                        </ins>
                      </span>
                      <p>
                        A dedicated and results-driven HR professional with 3+ years of 
                        experience in Talent Acquisition and HR Operations. Adept at managing 
                        end-to-end recruitment processes across PAN India, with a proven track
                        record in sourcing and hiring for diverse sectors such as Banking  , 
                        manufacturing, IT, and non-IT industries. Expertise in filling critical roles, 
                        including accountants, HR Business Partners (HRBPs), sales professionals, and 
                        frontend and full-stack developers.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={manish} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Manish Kumar</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>HR Managar (Payroll)</span>
                        </ins>
                      </span>
                      <p>
                     Manish Kumar, with 7 years of HR experience, specializes in employee relations. 
He oversees attendance, leave, and shift management, and supports employee engagement activities and internal communication. Assists with audits, HR reports, and policy implementation. he processes monthly payroll accurately and on time, handling salary calculations.
                      </p>
                    </div>
                  </div>
                </div>

           

                {/* Akriti 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={akriti} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Aakriti Mahajan</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span> Talent Acquisition Executive and HR Operations</span>
                        </ins>
                      </span>
                      <p>
                      Aakriti Mahajan, an HR Executive at Spinoff Technopark Ltd with over 3 years of experience, manages various human resources functions, including recruitment, employee onboarding, and record maintenance. She assists with performance management, handles employee relations, coordinates benefits, and performs administrative tasks to support efficient HR operations.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* TITLE START */}
      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">
              Producrement | Warehouse | Logistics | Commercial Team
            </h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Sunit Kumar 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sunit} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Sunit Kumar</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Procurement Head (LED Lighting)</span>
                        </ins>
                      </span>
                      <p>
                      Sunit Kumar, with 6 years of procurement experience at Spinoff Technopark, expertly manages supplier relationships, negotiates contracts, and streamlines purchasing processes. He drives cost efficiency and ensures timely, high-quality material deliveries.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Mohd Sahvan 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={sahvan} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Mohd Sahvan</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Procurement Head (Lithium Battery)</span>
                        </ins>
                      </span>
                      <p>
                      Mohd Sahvan, a Purchase Officer with over 9 years of experience, specializes in sourcing, negotiating, and purchasing materials from local and overseas vendors. He manages purchase orders, evaluates vendor performance, resolves supply issues, and ensures procurement strategies align with organizational goals for quality, delivery, and cost efficiency.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Yusuf Khan 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={yusuf} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Yusuf Khan</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Store Head Rajpura</span>
                        </ins>
                      </span>
                      <p>
                      Yusuf Khan, with over 15 years of store management experience, possesses in-depth knowledge of inventory control and team management. His comprehensive expertise enables informed decision-making and drives continuous improvement in store operations. {/* Enhanced tone and clarity */}
                      </p>
                    </div>
                  </div>
                </div>
                {/* Waseem Khan 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={waseem} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Waseem Khan</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Store Head Mohali</span>
                        </ins>
                      </span>
                      <p>
                      Waseem Khan, serving as Store and Logistics In-Charge since March 2023, brings eight years of experience in store management. He oversees inventory, ensures smooth logistics operations, and maintains efficient store processes to enhance overall business efficiency. {/* Spelled out "eight" and improved tone */}
                      </p>
                    </div>
                  </div>
                </div>
                {/* Vikas Kumar 3 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={vikas} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Vikas Kumar</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Team Member</span>
                        </ins>
                      </span>
                      <p>
                      Vikas Kumar, currently a Store In-Charge with 5 years of experience, values the family-like atmosphere at the company. This environment enhances his dedication and commitment to maintaining efficient store operations and contributing to overall success. {/* Spelled out "five" and improved flow */}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* TITLE START */}
      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">Architect | Interior Designer</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Arun Kumar 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={arun} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Arun Kumar</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Architect | Interior Designer</span>
                        </ins>
                      </span>
                      <p>
                      Arun Kumar, a seasoned architect with over 7 years of experience, demonstrates a strong passion for design excellence and sustainability. Proficient in Google SketchUp, Enscape, V-Ray, and AutoCAD, he has successfully delivered over 35 projects, consistently meeting deadlines and budget constraints.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* TITLE START */}
      <div className="section-head p-t10">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{
              backgroundImage: "url(images/background/cross-line2.png)",
            }}
          >
            <h3 className="sep-line-one">
              Customer Support Team &amp; Maintainance
            </h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      {/* SHOP SECTION START */}
      <div className="section-full p-t20 p-b50 bg-white mobile-page-padding">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 m-b30">
              <div className="shop-item-list-wrap-outer">
                {/* Parvinder Singh 1 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={parvinder} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Parvinder Singh</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>HOD Electric Maintenance & Security</span>
                        </ins>
                      </span>
                      <p>
                      Parvinder Singh, an electronics graduate with 18 years of experience, specializes in electronics, electrical systems, and networking. His expertise in installation, maintenance, and troubleshooting ensures efficient and reliable operations across diverse technical environments. {/* Enhanced tone and flow */}
                      </p>
                    </div>
                  </div>
                </div>
                {/* Rohit Shamra 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={rohit} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Rohit Sharma</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>TL After Sales</span>
                        </ins>
                      </span>
                      <p>
                      Rohit Sharma, with 10 years of experience in electronics, electrical systems, and networking, excels in installation, maintenance, and troubleshooting. His expertise ensures efficient operations and connectivity across various projects and environments.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Jagmohan Singh 2 */}
                <div className="shop-item-list-wrap m-b30">
                  <div className="sx-boxs sx-product-box   overflow-hide">
                    <div className="sx-thum-bx sx-img-overlay1">
                      <img src={jagmohan} alt="" />
                    </div>
                    <div className="sx-info">
                      <h5 className="sx-title">
                        <a href="#">Jagmohan Singh</a>
                      </h5>
                      <span className="price">
                        <ins>
                          <span>Team Member</span>
                        </ins>
                      </span>
                      <p>
                      Jagmohan Singh, with 12 years of experience in electronics, electrical systems, and networking, excels in installation, maintenance, and troubleshooting. His expertise ensures efficient operations and connectivity across diverse projects, delivering reliable solutions and performance.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ourteam;
